import React from "react"
import { Button } from "antd"
import { Icon } from "components"
import Strings from "utils/strings"
import { controlsContainerStyle, buttonStyle } from "../styles"

interface MapControlsProps {
	showPOIs: boolean
	showLegend: boolean
	onTogglePOIs: () => void
	onToggleLegend: () => void
}

const MapControls: React.FC<MapControlsProps> = ({
	showPOIs,
	showLegend,
	onTogglePOIs,
	onToggleLegend,
}) => (
	<div style={controlsContainerStyle}>
		<Button
			size="small"
			onClick={onTogglePOIs}
			style={{
				...buttonStyle,
				backgroundColor: showPOIs ? "#1890ff" : "white",
				color: showPOIs ? "white" : "rgba(0, 0, 0, 0.87)",
			}}
		>
			<Icon
				name={showPOIs ? "eye" : "eye-outline"}
				style={{
					fontSize: 14,
					color: showPOIs ? "white" : "rgba(0, 0, 0, 0.6)",
				}}
			/>
			<span>POIs</span>
		</Button>
		<Button
			size="small"
			onClick={onToggleLegend}
			style={{
				...buttonStyle,
				backgroundColor: showLegend ? "#1890ff" : "white",
				color: showLegend ? "white" : "rgba(0, 0, 0, 0.87)",
			}}
		>
			<Icon
				name="list"
				style={{
					fontSize: 14,
					color: showLegend ? "white" : "rgba(0, 0, 0, 0.6)",
				}}
			/>
			<span>{Strings.routes.fleetTracking.legend}</span>
		</Button>
	</div>
)

export default MapControls
